module.exports = __webpack_public_path__ + "assets/minusSignBig-adcbf0.svg";